<template lang="pug">
    
    .causes

        .divider.divider--one
            img(src='@/assets/img/divider-three.svg')
            img.flower(src='@/assets/img/flower.svg')
    
        .row.row--two-col
            .column.animate-apear.animate-apear--left(v-observe-visibility='{callback: blockVisibilityChanged, once: true, throttle: 300}')
                Heading(
                    tag='h2'
                    :text='data.heading'
                    color='white'
                    )
                p(v-html='data.paragraph[0]')

            .column.column--pl0.animate-apear.animate-apear(v-observe-visibility='{callback: blockVisibilityChanged, once: true, throttle: 300}')
                img.hands(src='@/assets/img/hands.svg')


        .row.row--two-col.row--align-center.row--flip-mob
            .column.column--mb0.animate-apear.animate-apear(v-observe-visibility='{callback: blockVisibilityChanged, once: true, throttle: 300}')
                img.dots-2(src='@/assets/img/dots2.svg')

            .column.column--mb0.animate-apear.animate-apear--right(v-observe-visibility='{callback: blockVisibilityChanged, once: true, throttle: 300}')
                p(v-html='data.paragraph[1]')


        .row.row--two-col.row--align-center
            .column.animate-apear.animate-apear--left(v-observe-visibility='{callback: blockVisibilityChanged, once: true, throttle: 300}')
                p(v-html='data.paragraph[2]')

            .column.animate-apear.animate-apear(v-observe-visibility='{callback: blockVisibilityChanged, once: true, throttle: 300}')
                img.factory(src='@/assets/img/factory.svg')
        
        SelectorMidsize(:data='data.selector')



</template>

<script>
import Heading from '@/components/utility/Heading.vue';

export default {
    name: 'Causes',

    components: {
        Heading,
        SelectorMidsize: () => import('@/components/utility/SelectorMidsize.vue')
    },

    props: {
        data: Object
    },

    methods: {
        blockVisibilityChanged(isVisible, el) {
            if (isVisible) el.target.classList.add('show');
        }
    }
};
</script>

<style lang="scss">
@import '@/assets/css/vars.scss';

.causes {
    position: relative;

    .flower {
        position: absolute;
        bottom: 12vw;
        right: 0;
        width: 20vw;
        height: calc(20vw * (381 / 374));

        @media (--viewport-mobile) {
            bottom: 17.5vw;
            right: -29vw;
            width: 80vw;
            height: calc(80vw * (381 / 374));
        }
    }

    &__last-row {
        @media (--viewport-mobile) {
            padding-bottom: 60vw;
        }
    }

    .hands {
        width: 100%;
        margin-top: 5vw;
    }

    .factory {
        width: 100%;
    }

    .dots-2 {
        margin-top: -10vw;
        margin-bottom: -2vw;

        @media (--viewport-mobile) {
            margin: 5vw 0;
        }
    }
}
</style>
